import { render } from "./FacebookIcon.vue?vue&type=template&id=2a636f8e&scoped=true"
import script from "./FacebookIcon.vue?vue&type=script&lang=js"
export * from "./FacebookIcon.vue?vue&type=script&lang=js"

import "./FacebookIcon.vue?vue&type=style&index=0&id=2a636f8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a636f8e"]])

export default __exports__